import _Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import i18n from '~/i18n'
import store from '~/store'
import { message } from '~/store/modules/notifications'

const toast = {
  success: async (message: string | TranslateResult) => {
    store.commit('notifications/displayMessage', {
      color: 'success',
      description: message,
      text: message,
      title: i18n.t('success'),
      icon: 'mdi-check-circle-outline',
    } as message)
  },
  error: async (message: string | TranslateResult) => {
    store.commit('notifications/displayMessage', {
      color: 'error',
      description: message,
      text: message,
      title: i18n.t('error'),
      icon: 'mdi-alert-circle-outline',
    } as message)
  },
  info: async (message: string | TranslateResult) => {
    store.commit('notifications/displayMessage', {
      color: 'info',
      description: message,
      text: message,
      title: i18n.t('info'),
      icon: 'mdi-information-outline',
    } as message)
  },
}

export default {
  install: (Vue: typeof _Vue) => {
    Vue.prototype.$toast = toast
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $toast: typeof toast
  }
}
